import WorkspaceSecondaryButton from "@/components/SecondaryButton";
import { Classroom } from "@/types/tutor";
import { useNavigate } from "react-router-dom";
import { Users, ArrowRight } from "lucide-react";
export default function ClassroomCard({ classroom }: { classroom: Classroom }) {
  const navigate = useNavigate();
  return (
    <article className="et-classroom-card">
      <Users aria-hidden="true" />
      <h3>{classroom.name}</h3>
      <WorkspaceSecondaryButton
        type="button"
        className="et-secondary-button"
        onClick={() => navigate(`/classroom/${classroom.id}`)}
      >
        View Classroom
        <ArrowRight size={16} />
      </WorkspaceSecondaryButton>
    </article>
  );
}
